export const API_URL = process.env.GATSBY_API_URL;

export const isPreProd = process.env.IS_PREPROD === 'true';

export const NEED_CONTRIBUTOR_ACTION_MESSAGE =
  'Il faut être connecté et à jour de cotisation pour faire cette action';

export const AUTHENTICATION_REQUIRED = 'AUTHENTICATION_REQUIRED';
